import { createDefaultTyrann } from '@apis/common';
import { user } from '@models/User';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const patchUserBody = t.partial(user.props);

export type PatchUserBody = t.TypeOf<typeof patchUserBody>;

export const registrationBody = t.type({
  email: t.string,
  password1: t.string,
  password2: t.string,
  company_name: t.string,
  first_name: t.string,
  last_name: t.string,
  cellphone: t.string,
  landline: t.string,
});

export type RegistrationBody = t.TypeOf<typeof registrationBody>;

export const passwordChangeBody = t.type({
  old_password: t.string,
  new_password1: t.string,
  new_password2: t.string,
});

export type PasswordChangeBody = t.TypeOf<typeof passwordChangeBody>;

export const passwordResetBody = t.type({
  uid: t.string,
  token: t.string,
  new_password1: t.string,
  new_password2: t.string,
});

export const userApis = createDefaultTyrann({
  '/login/': {
    post: {
      body: t.type({
        email: t.string,
        password: t.string,
      }),
      response: {
        200: t.type({
          key: t.string,
        }),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/jwt/login/': {
    post: {
      body: t.type({
        email: t.string,
        password: t.string,
      }),
      response: {
        200: t.type({
          refresh: t.string,
          access: t.string,
        }),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
        401: t.type({
          detail: t.string,
        }),
      },
    },
  },
  '/jwt/token/refresh/': {
    post: {
      body: t.type({
        refresh: t.string,
      }),
      response: {
        200: t.type({
          access: t.string,
        }),
        401: t.type({
          detail: t.string,
          code: t.string,
        }),
      },
    },
  },
  '/logout/': {
    post: {
      response: {
        200: t.type({}),
      },
    },
  },
  '/user/': {
    get: {
      response: {
        200: user,
      },
    },
    patch: {
      body: patchUserBody,
      response: {
        200: user,
        400: t.type({
          email: h.omittable(t.array(t.string)),
          non_field_errors: h.omittable(t.array(t.string)),
        }),
        409: t.type({
          email_duplicate_error: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/password/change/': {
    post: {
      body: passwordChangeBody,
      response: {
        200: t.type({}),
        400: t.type({
          old_password: h.omittable(t.array(t.string)),
          new_password1: h.omittable(t.array(t.string)),
          new_password2: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/password/reset/confirm/': {
    post: {
      body: passwordResetBody,
      response: {
        200: t.type({}),
        400: t.type({}),
      },
    },
  },
  '/registration/': {
    post: {
      body: registrationBody,
      response: {
        201: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/registration/verify-email/': {
    post: {
      body: t.type({
        key: t.string,
      }),
      response: {
        200: t.type({}),
      },
    },
  },
  '/registration/resend-email/': {
    post: {
      body: t.type({
        email: t.string,
      }),
      response: {
        200: t.type({}),
      },
    },
  },
});
